var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMirRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb5757;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16A16,16,0,1,1,16,32,16,16,0,0,1,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.09,14.88h-.41a.41.41,0,0,0-.41.4V16.5a3.26,3.26,0,0,1-3.6,3.23,3.34,3.34,0,0,1-2.94-3.37V15.28a.41.41,0,0,0-.41-.4h-.41a.4.4,0,0,0-.41.4v1a4.61,4.61,0,0,0,3.89,4.61v.87H14a.4.4,0,0,0-.4.41v.4A.4.4,0,0,0,14,23h4.1a.4.4,0,0,0,.4-.41v-.4a.4.4,0,0,0-.4-.41H16.61v-.86A4.48,4.48,0,0,0,20.5,16.5V15.28A.4.4,0,0,0,20.09,14.88ZM16,18.94a2.44,2.44,0,0,0,2.45-2.44V12.44a2.45,2.45,0,0,0-4.9,0V16.5A2.44,2.44,0,0,0,16,18.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirRed);
export default __webpack_public_path__ + "static/media/mir-red.edbb95607d94b5c2f286a01cf216556f.svg";
export { ForwardRef as ReactComponent };